/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Payment method:<br />
 * Cash - Payment is made at the hotel, including partial payment in the channel.<br />
 * PrePay - Full payment made in the channel.<br />
 * @export
 */
export const TravelinePaymentTypeDto = {
    Cash: 'Cash',
    PrePay: 'PrePay'
} as const;
export type TravelinePaymentTypeDto = typeof TravelinePaymentTypeDto[keyof typeof TravelinePaymentTypeDto];


export function instanceOfTravelinePaymentTypeDto(value: any): boolean {
    for (const key in TravelinePaymentTypeDto) {
        if (Object.prototype.hasOwnProperty.call(TravelinePaymentTypeDto, key)) {
            if (TravelinePaymentTypeDto[key as keyof typeof TravelinePaymentTypeDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelinePaymentTypeDtoFromJSON(json: any): TravelinePaymentTypeDto {
    return TravelinePaymentTypeDtoFromJSONTyped(json, false);
}

export function TravelinePaymentTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePaymentTypeDto {
    return json as TravelinePaymentTypeDto;
}

export function TravelinePaymentTypeDtoToJSON(value?: TravelinePaymentTypeDto | null): any {
    return value as any;
}

export function TravelinePaymentTypeDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelinePaymentTypeDto {
    return value as TravelinePaymentTypeDto;
}

